module.exports = __webpack_public_path__ + "static/thoughtful-lady-with-eyeglasses-6ca8009a898ff5115b48ba687997285c.jpg";